import { makeStyles } from '@material-ui/core/styles';
import { DIMENSIONS } from '../../styles/constants';

export const useStyles = makeStyles(theme => ({
	root: {
		flex: '1 1 100%',
		[theme.breakpoints.up('md')]: {
			display: 'inline-block',
			width: '100%'
		}
	},
	content: {
		[theme.breakpoints.up('md')]: {
			marginLeft: DIMENSIONS.SIDEPANEL_WIDTH + theme.spacing(3)
		},
		[theme.breakpoints.down('sm')]: {
			marginTop: theme.spacing(2)
		}
	},
	sidepanel: {
		width: DIMENSIONS.SIDEPANEL_WIDTH,
		float: 'left',
		[theme.breakpoints.down('sm')]: {
			width: '100%',
			float: 'none'
		}
	}
}));
